const LOCALE = "en-US";

const currencyFormatter = (currency: string) =>
  new Intl.NumberFormat(LOCALE, {
    style: "currency",
    currency: currency.toUpperCase()
  });

export const getCurrencySymbol = (currency: string): string => {
  const parts = currencyFormatter(currency.toUpperCase()).formatToParts(0);

  return parts.find((p) => p.type === "currency")?.value ?? currency.toUpperCase();
};

export const getCurrencyCode = (currency: string) => currency.toUpperCase();

export const formatCurrency = (value: number, currency: string) =>
  currencyFormatter(currency).format(value);
